<div class="modal-header">
    <h2 class="modal-title">User Detail</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form [formData]="user">
                <!-- <dxi-item dataField="userName" [isRequired]="true"></dxi-item> -->
                <dxi-item [label]="{ text: 'Roles' }">
                    <div *dxTemplate>
                        <dx-list
                            keyExpr="id"
                            [items]="roles"
                            height="700px"
                            [(selectedItemKeys)]="selectedRoleIds"
                            selectionMode="multiple"
                            [showSelectionControls]="true"
                            itemTemplate="listItem"
                            class="wrap roles-list"
                        >
                            <div *dxTemplate="let item of 'listItem'">
                                {{ item.name }}
                            </div>
                        </dx-list>
                    </div>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-danger" (click)="save()">Save</button>
    <button class="btn btn-success" (click)="cancel()">Close</button>
</div>
